import { render, staticRenderFns } from "./offPF.vue?vue&type=template&id=50233b6e&scoped=true&"
import script from "./offPF.vue?vue&type=script&lang=js&"
export * from "./offPF.vue?vue&type=script&lang=js&"
import style0 from "./offPF.vue?vue&type=style&index=0&id=50233b6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50233b6e",
  null
  
)

export default component.exports